"use strict";

exports.__esModule = true;
exports.dataHooks = void 0;
var dataHooks = {
  sliderTooltip: 'slider-tooltip',
  sliderHandle: 'slider-handle',
  sliderMarkLabel: 'slider-mark-label',
  sliderThumb: 'slider-thumb'
};
exports.dataHooks = dataHooks;
//# sourceMappingURL=constants.js.map